<template>
<div>
  <b-card no-body>
    <b-tabs card>
      <b-tab title="Mapa" disabled title-link-class="reenabled">
        <template slot="title">
          <strong>Mapa</strong>
        </template>
      </b-tab>
      <b-tab title="Filtro" active>
        <template v-for="(item, index) in metafilter">
          <FormComponent :metadata='item' :dbfield='metanames[index]' :key='"comp_"+index'
            v-model="filter[metanames[index]]" :isSearch="true" />
        </template>
        <b-button @click="loadList">Filtrar</b-button>
      </b-tab>
      <b-tab title="Riesgos">
        <table>
          <tr @click='toggleRiesgo(0)'>
            <td width="1%"><div style="background-color:rgb(0,176,80); width:40px; height:15px"></div></td>
            <td :style="riesgos[0]?'':'text-decoration: line-through'">Muy Bajo</td>
          </tr>
          <tr @click='toggleRiesgo(1)'>
            <td width="1%"><div style="background-color:rgb(146,208,80); width:40px; height:15px"></div></td>
            <td :style="riesgos[1]?'':'text-decoration: line-through'">Bajo</td>
          </tr>
          <tr @click='toggleRiesgo(2)'>
            <td width="1%"><div style="background-color:rgb(255,255,0); width:40px; height:15px"></div></td>
            <td :style="riesgos[2]?'':'text-decoration: line-through'">Moderado</td>
          </tr>
          <tr @click='toggleRiesgo(3)'>
            <td width="1%"><div style="background-color:rgb(255,192,0); width:40px; height:15px"></div></td>
            <td :style="riesgos[3]?'':'text-decoration: line-through'">Moderadamente Alto</td>
          </tr>
          <tr @click='toggleRiesgo(4)'>
            <td width="1%"><div style="background-color:rgb(255,0,0); width:40px; height:15px"></div></td>
            <td :style="riesgos[4]?'':'text-decoration: line-through'">Alto</td>
          </tr>
        </table>
      </b-tab>
      <b-tab title="Preparar Patrullaje">
        <recuperacion />
      </b-tab>
    </b-tabs>
  </b-card>
  <template>
    <l-map ref="myMap" style="height:400px">
      <l-control position="bottomleft">
        <div ref="parentModal">
          <Holdpoint :inspection="selectedInspection" v-on:ok="selectedInspection = null" />
        </div>
      </l-control>
    </l-map>
    <router-link ref = "checklist_link" style="display:none;" :to="{ name: 'inspection_view', params: { typex: this.$route.params.typex, json: this.$route.params.json, id: 9999 }}"> </router-link>
  </template>
</div>
</template>
<script>
import 'leaflet.markercluster/dist/MarkerCluster.css'
import 'leaflet.markercluster/dist/MarkerCluster.Default.css'
import '../assets/map/plugin/leaflet-distance-marker.css'
import 'leaflet-fullscreen/dist/leaflet.fullscreen.css'

import Base from './Base.vue'
import Recuperacion from './inspection/Recuperacion.vue'
import { L, LMap, LControl } from 'vue2-leaflet'
import 'leaflet.markercluster'
import '../assets/map/plugin/leaflet.geometryutil'
import '../assets/map/plugin/leaflet-distance-marker.js'
import 'leaflet-fullscreen/dist/Leaflet.fullscreen'

import proj4 from 'proj4'
import FormComponent from './FormComponents/FormComponent.vue'
import Holdpoint from './inspection/Holdpoint.vue'
import * as d3 from 'd3'

const CASHIRIARI = require('../assets/map/data/cashiriari.js').default
const MIPAYA_MIPAYA = require('../assets/map/data/mipaya_mipaya.js').default
const MIPAYA_PAGORENI = require('../assets/map/data/mipaya_pagoreni.js').default
const PAGORENI = require('../assets/map/data/pagoreni.js').default
const SAGARI = require('../assets/map/data/sagari.js').default
const SAN_MARTIN = require('../assets/map/data/san_martin_i_a_iii.js').default
const SAN_MARTIN_MALVINAS = require('../assets/map/data/san_martin_malvinas_i_5.js').default
const U200 = require('../assets/map/data/u200.js').default
const U600 = require('../assets/map/data/u600.js').default
const MLV = require('../assets/map/data/mlv.js').default

export default {
  extends: Base,
  components: {
    LMap,
    LControl,
    Recuperacion,
    FormComponent,
    Holdpoint
  },
  data () {
    return {
      features: [],
      metafilter: [],
      metajoined: [],
      metanames: [],
      filter: {},
      markerclusters: null,
      list: [],
      selectedInspection: null,
      showModal: false,
      riesgos: [true, true, true, true, true]
    }
  },
  watch: {
    db (to, from) {
      this.loadFilter()
      // this.loadHeader()
      if (to) {
        this.loadList()
      } else {
        this.clearList()
      }
    },
    selectedInspection (to, from) {
      var map = this.$refs['myMap']
      if (to) {
        map.mapObject._handlers.forEach(function (handler) {
          handler.disable()
        })
      } else {
        map.mapObject._handlers.forEach(function (handler) {
          handler.enable()
        })
      }
    },
    /* filter: {
      handler: function (value) {
        var obj = this
        var copy = Object.assign({}, value)
        // no captura el oldvalue
        if ('flowline' in copy && 'platform' in copy && copy.flowline !== null && copy.platform !== null) {
          console.log('flowline', Object.keys(copy).indexOf('flowline'), 'platform', Object.keys(copy).indexOf('platform'))
          if (Object.keys(copy).indexOf('flowline') < Object.keys(copy).indexOf('platform')) {
            delete copy.flowline
            console.log('New filter only platform', copy)
          } else {
            delete copy.platform
            console.log('New filter only flowline', copy)
          }
          value = Object.assign({}, copy)
        }
        console.log('value', value)
        console.log('obj.filter', obj.filter)
      },
      deep: true
    }, */
    list (to, from) {
      this.update()
    }
  },
  methods: {
    update () {
      let obj = this
      var features = []
      var fromProj = '+proj=utm +zone=18 +south +ellps=WGS84 +datum=WGS84 +units=m +no_defs'
      var toProj = 'EPSG:4326'
      obj.list.forEach(element => {
        var east = (element && element.location && element.location.east_coordinate)
          ? parseInt(element.location.east_coordinate) || null : null
        var north = (element && element.location && element.location.north_coordinate)
          ? parseInt(element.location.north_coordinate) || null : null
        var coord = (east && north)
        var ifrm = (element.ifrm && element.ifrm.ifrm_value) ? element.ifrm.ifrm_value : 0
        var color = 'rgb(200,200,200)'
        if (ifrm <= 10) {
          color = 'rgb(0,176,80)'
        } else if (ifrm <= 20) {
          color = 'rgb(146,208,80)'
        } else if (ifrm <= 32) {
          color = 'rgb(255,255,0)'
        } else if (ifrm <= 42) {
          color = 'rgb(255,192,0)'
        } else {
          color = 'rgb(255,0,0)'
        }
        element.color = color
        var geojsonFeature = {
          'type': 'Feature',
          'properties': {
            'obj': element
          },
          'geometry': {
            'type': 'Point',
            'coordinates': proj4(fromProj, toProj, coord ? [east, north] : [702724, 8694132])
          }
        }
        var check = [-1, 10, 20, 32, 42]
        var valid = true
        for (var i = 0; i < 4; i++) {
          if (ifrm > check[i] && ifrm <= check[i + 1] && !obj.riesgos[i]) {
            valid = false
          }
        }
        if (valid) features.push(geojsonFeature)
      })
      var map = obj.$refs.myMap.mapObject
      if (map) {
        var myLayer = L.geoJSON(features, {
          onEachFeature: obj.defineFeaturePopup,
          pointToLayer: function (feature, latlng) {
            return L.circleMarker(latlng, {
              color: feature.properties.obj.color,
              fillColor: feature.properties.obj.color,
              fillOpacity: 0.9,
              radius: 10
            })
          }
        })
        var markerclusters = L.markerClusterGroup({
          maxClusterRadius: 24,
          spiderLegPolylineOptions: { color: 'white' },
          iconCreateFunction: obj.defineClusterIcon
        })
        if (obj.markerclusters) {
          map.removeLayer(obj.markerclusters)
        }
        map.addLayer(markerclusters)
        markerclusters.addLayer(myLayer)
        obj.markerclusters = markerclusters
      } else {
        console.log('no map')
      }
      obj.$set(obj, 'features', features)
    },
    toggleRiesgo (x) {
      this.$set(this.riesgos, x, !this.riesgos[x])
      this.update()
    },
    eachRecursive (index, joinedindex, obj, func) {
      for (var k in obj) {
        if (typeof obj[k] === 'object' && obj[k] !== null) {
          this.eachRecursive(k, joinedindex + '.' + k, obj[k], func)
          func(k, joinedindex + '.' + k, obj[k], true)
        } else {
          func(k, joinedindex + '.' + k, obj[k], false)
        }
      }
    },
    loadFilter () {
      var obj = this
      obj.metafilter = []
      obj.metanames = []
      this.eachRecursive('', '', this.metadata, function (metaname, joinedname, elem, isobject) {
        if (isobject && elem.search) {
          obj.metanames.push(metaname)
          obj.metajoined.push(joinedname.substr(1).replace(/.children/g, '').replace(/.choices.0/g, ''))
          obj.metafilter.push(elem)
        }
      })
    },
    loadList () {
      let obj = this
      obj.isBusy = true
      if (!obj.db) { return }
      var selector = {
        $and: [
          { _id: { $ne: '_design/app' } },
          { _id: { $ne: '_design/index' } }
        ]
      }
      for (var i in obj.metafilter) {
        if (obj.metanames[i] in obj.filter) {
          if (obj.metafilter[i].search.stype === 'range') {
            var partialfilter = {}
            partialfilter[obj.metajoined[i]] = {}
            if (obj.filter[obj.metanames[i]].start && obj.filter[obj.metanames[i]].start !== '') {
              partialfilter[obj.metajoined[i]]['$gte'] = obj.filter[obj.metanames[i]].start
            }
            if (obj.filter[obj.metanames[i]].end && obj.filter[obj.metanames[i]].end !== '') {
              partialfilter[obj.metajoined[i]]['$lte'] = obj.filter[obj.metanames[i]].end
            }
            if (!((!obj.filter[obj.metanames[i]].start || obj.filter[obj.metanames[i]].start === '') &&
              (!obj.filter[obj.metanames[i]].end || obj.filter[obj.metanames[i]].end === ''))) {
              selector['$and'].push(partialfilter)
            }
          } else if (obj.metafilter[i].search.stype === 'exists') {
            if (obj.filter[obj.metanames[i]]) {
              if (obj.filter[obj.metanames[i]].includes('si')) {
                if (!obj.filter[obj.metanames[i]].includes('no')) {
                  partialfilter = {}
                  partialfilter[obj.metajoined[i]] = {
                    $exists: true
                  }
                  selector['$and'].push(partialfilter)
                  partialfilter = {}
                  partialfilter[obj.metajoined[i]] = {
                    $ne: ''
                  }
                  selector['$and'].push(partialfilter)
                }
              } else if (obj.filter[obj.metanames[i]].includes('no')) {
                var elem = {}
                elem['$or'] = []
                partialfilter = {}
                partialfilter[obj.metajoined[i]] = {
                  $exists: false
                }
                elem['$or'].push(partialfilter)
                partialfilter = {}
                partialfilter[obj.metajoined[i]] = {
                  $eq: ''
                }
                elem['$or'].push(partialfilter)
                selector['$and'].push(elem)
              }
            }
          } else if (obj.filter[obj.metanames[i]] !== null) {
            partialfilter = {}
            partialfilter[obj.metajoined[i]] = {
              $eq: obj.filter[obj.metanames[i]]
            }
            if (obj.filter[obj.metanames[i]] && obj.filter[obj.metanames[i]] !== '') {
              selector['$and'].push(partialfilter)
            }
          }
        }
      }
      /* parche */
      for (var select in selector.$and) {
        if ('identification.choices.1.platform' in selector.$and[select]) {
          selector.$and[select]['identification.platform'] = selector.$and[select]['identification.choices.1.platform']
          delete selector.$and[select]['identification.choices.1.platform']
        }
      }
      var search = {
        selector: selector,
        limit: 2000,
        fields: ['_id', 'identification', 'landslide.inspection_date', 'ifrm.ifrm_value', 'location'],
        sort: [{ 'landslide.inspection_date': 'desc' }]
      }
      obj.db.find(search).then(function (list) {
        var newlist = list.docs.reduce(function (ant, cur, ind, arr) {
          var add = true
          var curp = {}
          curp['flowline'] = cur.identification && cur.identification.flowline ? cur.identification.flowline : null
          curp['progressive'] = cur.identification && cur.identification.progressive ? cur.identification.progressive : null
          curp['side_to_ddv'] = cur.identification && cur.identification.side_to_ddv ? cur.identification.side_to_ddv : null
          curp['platform'] = cur.identification && cur.identification.platform ? cur.identification.platform : null
          curp['instalation'] = cur.identification && cur.identification.instalation ? cur.identification.instalation : null
          curp['talud'] = cur.identification && cur.identification.talud ? cur.identification.talud : null
          for (var i in ant) {
            var antp = {}
            antp['flowline'] = ant[i].identification && ant[i].identification.flowline ? ant[i].identification.flowline : null
            antp['progressive'] = ant[i].identification && ant[i].identification.progressive ? ant[i].identification.progressive : null
            antp['side_to_ddv'] = ant[i].identification && ant[i].identification.side_to_ddv ? ant[i].identification.side_to_ddv : null
            antp['platform'] = ant[i].identification && ant[i].identification.platform ? ant[i].identification.platform : null
            antp['instalation'] = ant[i].identification && ant[i].identification.instalation ? ant[i].identification.instalation : null
            antp['talud'] = ant[i].identification && ant[i].identification.talud ? ant[i].identification.talud : null
            if (curp['flowline'] === antp['flowline'] &&
              curp['progressive'] === antp['progressive'] &&
              curp['side_to_ddv'] === antp['side_to_ddv'] &&
              curp['platform'] === antp['platform'] &&
              curp['instalation'] === antp['instalation'] &&
              curp['talud'] === antp['talud']) {
              if (cur.landslide && cur.landslide.inspection_date && ant[i].landslide && ant[i].landslide.inspection_date) {
                if (cur.landslide.inspection_date >= ant[i].landslide.inspection_date) {
                  ant[i] = cur
                }
              } else {
                ant[i] = cur
              }
              add = false
            }
          }
          if (add) {
            ant.push(cur)
          }
          return ant
        }, [])
        obj.$set(obj, 'list', newlist)
      }).catch(function (err) {
        console.log(err)
        if ('message' in err) {
          obj.msg = err.message
        } else {
          obj.msg = err.toString()
        }
        obj.setMessage('loadList: ' + JSON.stringify(err))
      })
    },
    clearList () {
      // this.$set(this, 'list', [])
      var map = this.$refs.myMap.mapObject
      if (map && this.markerclusters) {
        map.removeLayer(this.markerclusters)
      }
    },
    progressives (json, color) {
      var resp = L.polyline([], {
        color: color, distanceMarkers: { lazy: false, iconSize: [16, 16] }
      })
      for (var i = 0; i < json.features.length; i++) {
        var feature = json.features[i]
        for (var j = 0; j < feature.geometry.coordinates.length; j++) {
          var line = feature.geometry.coordinates[j]
          for (var k = 0; k < line.length; k++) {
            resp.addLatLng([line[k][1], line[k][0]])
          }
        }
      }
      // resp.refreshMarkers()
      return resp
    },
    getInspectionName (feature) {
      if (feature) {
        var insp = feature.properties.obj
        var title = ''
        if (insp.identification && insp.identification.type && insp.identification.type === 'plataforma') {
          var titulo = ''
          var parcial = ''
          for (var i in this.metadata.identification.choices[1].children.platform.choices) {
            parcial = this.metadata.identification.choices[1].children.platform.choices[i]
            if (insp.identification.platform === parcial.value) {
              titulo = titulo + parcial.display_name
            }
          }
          for (i in this.metadata.identification.choices[1].children.instalation.choices) {
            parcial = this.metadata.identification.choices[1].children.instalation.choices[i]
            if (insp.identification.instalation === parcial.value) {
              titulo = titulo + ' - ' + parcial.display_name
            }
          }
          for (i in this.metadata.identification.choices[1].children.talud.choices) {
            parcial = this.metadata.identification.choices[1].children.talud.choices[i]
            if (insp.identification.talud === parcial.value) {
              titulo = titulo + ' - ' + parcial.display_name
            }
          }
          return titulo
        } else {
          for (i in this.metadata.identification.choices[0].children.flowline.choices) {
            var j = this.metadata.identification.choices[0].children.flowline.choices[i]
            if (insp.identification) {
              if (j.value === insp.identification.flowline) {
                if (parseInt(insp.identification.progressive % 1000) > 99) {
                  if (parseInt(insp.identification.progressive / 1000) > 9) {
                    title = '<b>' + j.display_name + '</b> PK' +
                    parseInt(insp.identification.progressive / 1000) + '+' + parseInt(insp.identification.progressive % 1000)
                  } else {
                    title = '<b>' + j.display_name + '</b> PK' +
                    '0' + parseInt(insp.identification.progressive / 1000) + '+' + parseInt(insp.identification.progressive % 1000)
                  }
                } else if (parseInt(insp.identification.progressive % 1000) > 9) {
                  if (parseInt(insp.identification.progressive / 1000) > 9) {
                    title = '<b>' + j.display_name + '</b> PK' +
                    parseInt(insp.identification.progressive / 1000) + '+0' + parseInt(insp.identification.progressive % 1000)
                  } else {
                    title = '<b>' + j.display_name + '</b> PK' +
                    '0' + parseInt(insp.identification.progressive / 1000) + '+0' + parseInt(insp.identification.progressive % 1000)
                  }
                } else {
                  if (parseInt(insp.identification.progressive / 1000) > 9) {
                    title = '<b>' + j.display_name + '</b> PK' +
                    parseInt(insp.identification.progressive / 1000) + '+00' + parseInt(insp.identification.progressive % 1000)
                  } else {
                    title = '<b>' + j.display_name + '</b> PK' +
                    '0' + parseInt(insp.identification.progressive / 1000) + '+00' + parseInt(insp.identification.progressive % 1000)
                  }
                }
              }
            }
          }
        }
        return title
      }
    },
    defineFeaturePopup (feature, layer) {
      var obj = this
      /* var progressive = feature.properties.obj.identification ? feature.properties.obj.identification.progressive : ''
      var inspectionDate = feature.properties.obj.landslide ? feature.properties.obj.landslide.inspection_date : ''
      var url = this.$refs.checklist_link.$el.href.replace('9999', feature.properties.obj._id)
      var html = '<div><table>'
      html += '<tr><td><b>' + 'Progresiva' + '</b></td><td>' + progressive + '</td></tr>'
      html += '<tr><td><b>' + 'Fecha' + '</b></td><td>' + inspectionDate + '</td></tr>'
      html += '<tr><td style="text-align:center" colspan="2"><a target="_blank" href="' + url + '">Ver detalle</a></td>'
      html += '</table></div>'
      layer.bindPopup(html, { offset: L.point(1, -2) }) */
      this.getInspectionName(feature)
      layer.on('click', function () {
        obj.$set(obj, 'selectedInspection', feature.properties.obj)
        obj.$set(obj, 'showModal', true)
      }).bindTooltip(this.getInspectionName(feature))
    },
    checklist () {
      console.log('test')
    },
    defineClusterIcon (cluster) {
      var children = cluster.getAllChildMarkers()
      var n = children.length
      var strokeWidth = 1
      var r = n < 5 ? 16 : n < 50 ? 18 : n < 100 ? 20 : 22
      var iconDim = (r + strokeWidth) * 2
      var data = d3.nest()
        .key(function (d) { return d.feature.properties.obj.color })
        .entries(children, d3.map)
      var html = this.bakeThePie({
        data: data,
        valueFunc: function (d) { return d.values.length },
        strokeWidth: 1,
        outerRadius: r,
        innerRadius: r - 10,
        pieClass: 'cluster-pie',
        pieLabel: n,
        pieLabelClass: 'marker-cluster-pie-label',
        /* pathClassFunc: function (d) { return "category-" + d.data.key }, */
        pathColorFunc: function (d) { return d.data.key },
        pathTitleFunc: function (d) {
          switch (d.data.key) {
            case 'rgb(200,200,200)':
              return 'NA :' + d.data.values.length
            case 'rgb(0,176,80)':
              return 'Muy Bajo :' + d.data.values.length
            case 'rgb(146,208,80)':
              return 'Bajo :' + d.data.values.length
            case 'rgb(255,255,0)':
              return 'Moderado :' + d.data.values.length
            case 'rgb(255,192,0)':
              return 'Moderadamente Alto :' + d.data.values.length
            default:
              return 'Alto :' + d.data.values.length
          }
        }
      })
      var myIcon = new L.DivIcon({
        html: html,
        className: 'marker-cluster',
        iconSize: new L.Point(iconDim, iconDim)
      })
      return myIcon
    },
    bakeThePie (options) {
      if (!options.data || !options.valueFunc) {
        return ''
      }
      var data = options.data
      var valueFunc = options.valueFunc
      var r = options.outerRadius ? options.outerRadius : 28
      var rInner = options.innerRadius ? options.innerRadius : r - 10
      var strokeWidth = options.strokeWidth ? options.strokeWidth : 1
      var pathClassFunc = options.pathClassFunc ? options.pathClassFunc : function () { return '' }
      var pathTitleFunc = options.pathTitleFunc ? options.pathTitleFunc : function () { return '' }
      var pathColorFunc = options.pathColorFunc ? options.pathColorFunc : function () { return '' }
      var pieClass = options.pieClass ? options.pieClass : 'marker-cluster-pie'
      var pieLabel = options.pieLabel ? options.pieLabel : d3.sum(data, valueFunc)
      var pieLabelClass = options.pieLabelClass ? options.pieLabelClass : 'marker-cluster-pie-label'

      var origo = (r + strokeWidth)
      var w = origo * 2
      var h = w
      var donut = d3.pie()
      var arc = d3.arc().innerRadius(rInner).outerRadius(r)

      var svg = document.createElementNS(d3.namespaces.svg, 'svg')

      var vis = d3.select(svg)
        .data([data])
        .attr('class', pieClass)
        .attr('width', w)
        .attr('height', h)

      vis.append('circle').attr('cx', origo).attr('cy', origo).attr('r', r).style('fill', 'rgba(255,255,255,0.8)')

      var arcs = vis.selectAll('g.arc')
        .data(donut.value(valueFunc))
        .enter().append('svg:g')
        .attr('class', 'arc')
        .attr('transform', 'translate(' + origo + ',' + origo + ')')

      arcs.append('svg:path')
        .attr('class', pathClassFunc)
        .attr('fill', pathColorFunc)
        .attr('stroke', '#222')
        .attr('stroke-width', strokeWidth)
        .attr('d', arc)
        .append('svg:title')
        .text(pathTitleFunc)

      vis.append('text')
        .attr('x', origo)
        .attr('y', origo)
        .attr('class', pieLabelClass)
        .attr('text-anchor', 'middle')
        .attr('dy', '.3em')
        .text(pieLabel)

      return this.serializeXmlNode(svg)
    },
    serializeXmlNode (xmlNode) {
      if (typeof window.XMLSerializer !== 'undefined') {
        return (new window.XMLSerializer()).serializeToString(xmlNode)
      } else if (typeof xmlNode.xml !== 'undefined') {
        return xmlNode.xml
      }
      return ''
    }
  },
  mounted () {
    var obj = this
    this.$nextTick(() => {
      var esriWorldImagery = L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}', {
        maxZoom: 20,
        maxNativeZoom: 17,
        attribution: 'Tiles &copy; Esri'
      })
      var map = this.$refs.myMap.mapObject
      map.addLayer(esriWorldImagery)
      map.fitBounds([[-12.053527561118816, -73.49508936821934], [-11.347245729843586, -72.21236709015473]])
      map.addLayer(obj.progressives(U200, 'rgba(156, 43, 216,1.0)'))
      map.addLayer(obj.progressives(U600, 'rgba(43, 209, 52,1.0)'))
      map.addLayer(obj.progressives(MLV, 'rgba(100, 209, 52,1.0)'))
      map.addLayer(obj.progressives(CASHIRIARI, 'rgba(255,96,17,1.0)'))
      map.addLayer(obj.progressives(MIPAYA_MIPAYA, 'rgba(235,209,141,1.0)'))
      map.addLayer(obj.progressives(MIPAYA_PAGORENI, 'rgba(235,209,141,1.0)'))
      map.addLayer(obj.progressives(PAGORENI, 'rgba(0,153,235,1.0)'))
      map.addLayer(obj.progressives(SAN_MARTIN, 'rgba(235,43,0,1.0)'))
      map.addLayer(obj.progressives(SAN_MARTIN_MALVINAS, 'rgba(235,43,0,1.0)'))
      map.addLayer(obj.progressives(SAGARI, 'rgba(68,210,231,1.0)'))
      map.addControl(new L.Control.Fullscreen({ pseudoFullscreen: true }))

      /* var Mfilter = L.Control.extend({
        onAdd: function (map) {
          var div = L.DomUtil.create('div')

          div.style.width = '200px'
          div.innerHTML = 'whatever'

          return div
        },

        onRemove: function (map) {
          // Nothing to do here
        }
      })
      var mfilter = new Mfilter()
      mfilter.addTo(map)
      console.log(mfilter) */
    })
  }
}
</script>

<style>
.nav-tabs .nav-link.reenabled {
  color: black;
  font-weight: 400;
}
.leaflet-div-icon {
    background: none;
    border: none;
}
</style>
